import { styled } from '@mui/material';

import { PeopleIcon, RobotIcon } from '@app-velocity/icons';

const Stats = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const Stat = styled('div')(({ theme }) => ({
  gap: theme.spacing(1),
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  fontSize: 12,
  fontWeight: 700,
  minWidth: theme.spacing(12),
  svg: {
    fill: '#7a7a7a',
    width: 14,
  },
}));

export type ConfidenceStatsProps = {
  human?: string;
  simulations?: string;
};

export const ConfidenceStats = ({
  human,
  simulations,
}: ConfidenceStatsProps) => {
  return (
    <Stats>
      {human ? (
        <Stat>
          {human}
          <PeopleIcon />
        </Stat>
      ) : null}
      {simulations ? (
        <Stat>
          {simulations}
          <RobotIcon />
        </Stat>
      ) : null}
    </Stats>
  );
};
